import React from 'react'
import { Row } from '../components/layout'
import styled from 'styled-components'
import { useStore } from 'effector-react'
import store, { setState$ } from '../store'
import { onMobile, onTablet, title1 } from '../utils/selector'
import { pickerStore } from './store'

export default function Picker() {
  const state = useStore(store)
  const { showError } = useStore(pickerStore)

  return (
    <Row alignment="center" id="picker">
      <Row gutter={32}>
        <PickerItem>
          <Title
            htmlFor="state-picker"
            style={{ color: showError && !state.state && 'red' }}
          >
            注册州*：
          </Title>
          <Select
            id="state-picker"
            value={state.state}
            onChange={e => setState$({ state: e.currentTarget.value as any })}
          >
            <option value=""></option>
            <option value="DE">DE</option>
            <option value="CA">CA</option>
          </Select>
        </PickerItem>
        <PickerItem>
          <Title
            htmlFor="type-picker"
            style={{ color: showError && !state.type && 'red' }}
          >
            实体类型*：
          </Title>
          <Select
            id="type-picker"
            value={state.type}
            onChange={e => setState$({ type: e.currentTarget.value as any })}
          >
            <option value=""></option>
            <option value="CCORP">CCORP</option>
            <option value="LLC">LLC</option>
          </Select>
        </PickerItem>
      </Row>
    </Row>
  )
}

const PickerItem = styled.div`
  display: flex;

  ${onTablet} {
    align-items: center;
  }

  ${onMobile} {
    flex-direction: column;
  }
`

const Title = styled.label`
  ${title1}

  ${onTablet} {
    margin-right: 0.5em;
  }

  ${onMobile} {
    margin-bottom: 0.5em;
  }
`

const Select = styled.select`
  font-size: 16px;
  padding: 4px 8px;
`
